import { METARAPIParser } from '../../utils/METARUtils'
import { TWS_API_URL } from '../../environment/apis.config'
import { timeouts } from '../RequestTimeouts'
import { getAccessToken } from '../../utils/auth.util';

export const fetchMETARData = async (
  latitude: string,
  longitude: string | undefined,
  controller: AbortController,
  signal: AbortSignal
) => {
  const distance = 100

  return new Promise(async (resolve, reject) => {
    const timeoutId = setTimeout(() => {
      controller.abort()
      reject(new Error('METAR request timed out. Please try again.'))
    }, timeouts.metar)
    const token = await getAccessToken()

    const response = await fetch(
      `${TWS_API_URL}/metarsAviation?location=${latitude},${longitude},${distance}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        signal,
      }
    )
      .then((res) => {
        clearTimeout(timeoutId)
        if (!res.ok) {
          throw new Error(
            'Failed to fetch METAR dara' /*reject(response.status*/
          )
        }
        return res.json()
      })
      .then((data) => {
        resolve(METARAPIParser(data))
      })
      .catch((error) => {
        if (controller.signal.aborted) {
          reject(new Error('METAR request aborted.'))
        } else {
          reject(error)
        }
      })
  })
}

export default fetchMETARData
